export default __webpack_public_path__ + "img/EconLogo2.15894b42.png";